import { createSlice } from "@reduxjs/toolkit";

// Define the initial state
export const initialState = {
  publisher: { currentPage: 1, totalPage: 0 },
  consumer: { currentPage: 1, totalPage: 0 },
  serviceConsumer: { currentPage: 1, totalPage: 0 },
  servicePublisher: { currentPage: 1, totalPage: 0 },
  meriConsumer: { currentPage: 1, totalPage: 0 },
};

// Create a slice using createSlice
export const paginationSlice = createSlice({
  name: "pagination",
  initialState,
  reducers: {
    // Reducer to set the current page for a specific key
    setCurrentPage: (state, action) => {
      const { key, page } = action.payload;
      if (state[key]) {
        state[key].currentPage = page + 1;
      }
    },
    // Reducer to set the total pages for a specific key
    setTotalPage: (state, action) => {
      const { key, page } = action.payload;
      if (state[key]) {
        state[key].totalPage = page;
      }
    },
    // Reducer to reset the current page for a specific key
    resetCurrentPage: (state, action) => {
      const { key } = action?.payload;
      if (state[key]) {
        state[key].currentPage = initialState[key].currentPage;
      }
    },
    // Reducer to reset the total pages for a specific key
    resetTotalPage: (state, action) => {
      const { key } = action.payload;
      if (state[key]) {
        state[key].totalPage = initialState[key].totalPage;
      }
    },
    // Reducer to reset pagination to the initial state for all keys
    resetPage: () => {
      return JSON.parse(JSON.stringify(initialState)); // Ensures deep copy
    },
  },
});

// Export the generated action creators
export const {
  setCurrentPage,
  setTotalPage,
  resetCurrentPage,
  resetTotalPage,
  resetPage,
} = paginationSlice.actions;

// Export the reducer
export default paginationSlice.reducer;
